<template>
  <div class="rounded-lg p-3 bg-white mb-2">
    <div class="flex">
      <div class="fs-20 fw-500 ml-1">
        {{ name }}
      </div>
      <div @click="createPrescription()"
        class="cursor-pointer ml-auto p-2 w-36 rounded-lg border border-primary flex justify-center items-center">
        <img src="@public/assets/images/icon/patientVisit/plus-circle.svg" alt />
        <p class="ml-2 text-primary font-weight-bold mb-0">
          {{ $t("schedule_page.lbl_Prescriptions") }}
        </p>
      </div>
    </div>
    <div class="mt-3" v-if="prescriptionsLocal && prescriptionsLocal.length">
      <el-collapse class="hodo-el-collapse" v-model="activeCollapseItems" @change="handleChangeCollapse">
        <el-collapse-item :name="`collapse-${index}`"
          v-for="(item, index) in prescriptionsLocal.filter(prescription => Array.isArray(prescription.person_medicine) && prescription.person_medicine.length > 0)"
          :key="item.id || item._localId">
          <template slot="title">
            <div class="w-full flex items-center justify-between">
              <div class="flex items-center font-medium txt-pri hover:text-blue-600 transition-all duration-200">
                <i class="el-icon-arrow-right collapse-arrow mr-2"
                  :class="{ rotated: activeCollapseItems.includes(`collapse-${index}`) }"
                  @click.stop="toggleCollapse(index)"></i>
                <span class="mr-1">{{ `${$t(item.name)} (${item.person_medicine.length})` }}</span>
              </div>
              <div class="flex items-center">
                <template v-if="!item.id">
                  <el-button size="mini" class="action-btn mx-1 text-primary"
                    @click.stop="editPrescription(item, index)">
                    <i class="el-icon-edit"></i>
                  </el-button>
                  <el-button size="mini" class="action-btn mx-1 text-danger" @click.stop="confirmDelete(item.id, index)">
                    <i class="el-icon-delete"></i>
                  </el-button>
                </template>
              </div>
            </div>
          </template>
          <div>
            <div v-for="(medicine, index) in item.person_medicine" :key="medicine.pharma_product_id"
              :class="index < item.person_medicine.length ? 'border-b border-t-0 border-r-0 border-l-0 border-solid border-gray-200' : ''"
              class="group flex justify-between hover:bg-gray-100 transition-all duration-200 px-2 py-1" role="button">
              <div class="relative transition-all duration-200 w-full pr-2 cursor-pointer flex-1">
                <span class="txt-pri">{{ medicine.name }}</span>
              </div>
              <div class="mr-3">{{ `x ${medicine.amount || 1}` }}</div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <ModalAddPrescription ref="ModalAddPrescription" :parentForm="form" :type="type"
      @savePrescription="onUpdatePrescription" @refresh="refreshAndOpenPreview"
      @updateIsPhieuLinh="handleUpdateIsPhieuLinh" />

  </div>
</template>
<style scoped lang="scss">
::v-deep {
  .hodo-el-collapse {
    .el-collapse-item {
      &__header {
        height: auto;
        line-height: normal;
        padding: 8px 0;
      }

      &__wrap {
        border-bottom: none;
      }

      &__content {
        padding-bottom: 8px;
      }
    }
  }
}

.collapse-arrow {
  font-size: 14px;
  line-height: 1;
  transition: transform 0.12s ease;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
}

.collapse-arrow.rotated {
  transform: rotate(90deg);
}

.action-btn {
  padding: 4px;
  border-radius: 50%;
  min-width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: none !important;
  color: inherit;
  transition: background-color 0.12s ease, transform 0.12s ease, border-color 0.12s ease;
}

::v-deep .hodo-el-collapse .el-collapse-item__header .el-collapse-item__arrow {
  display: none !important;
}

.action-btn i {
  font-size: 14px;
  line-height: 1;
  color: inherit;
  opacity: 1 !important;
}

.action-btn:hover {
  transform: translateY(-1px);
}

.action-btn:hover i {
  color: #fff !important;
}

.action-btn.text-primary i {
  color: var(--hodo-primary, #1e90ff) !important;
}

.action-btn.text-danger i {
  color: var(--hodo-danger, #ef4444) !important;
}

.action-btn.text-primary:hover {
  background-color: var(--hodo-primary, #1e90ff) !important;
}

.action-btn.text-primary:hover i {
  color: #fff !important;
}

.action-btn.text-danger:hover {
  background-color: var(--hodo-danger, #ef4444) !important;
}

.action-btn.text-danger:hover i {
  color: #fff !important;
}

.action-btn.text-primary {
  background-color: #fff !important;
  border-color: rgba(0, 0, 0, 0.06) !important;
}

.action-btn.text-danger {
  background-color: #fff !important;
  border-color: rgba(0, 0, 0, 0.06) !important;
}
</style>
<script>
import appUtils from '@/utils/appUtils'
import {
  EXAMINATION_STATUS
} from '@/utils/constants'
import ModalAddPrescription from './Components/ModalAdd.vue'

export default {
  name: 'PrescriptionTemp',
  components: {
    ModalAddPrescription
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    disease: {
      type: Object
    },
    type: {
      type: String,
      default: ''
    },
    reset: {
      type: Number,
      default: 0
    },
    items: {
      type: Array,
      default: undefined
    },
    isPhieuLinh: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      appUtils,
      EXAMINATION_STATUS,
      activeCollapseItems: ['collapse-0'],
      prescriptionsLocal: Array.isArray(this.items) ? this._normalizeItems([...this.items]) : []
    }
  },
  watch: {
    items: {
      handler (newVal) {
        this.prescriptionsLocal = Array.isArray(newVal) ? this._normalizeItems([...newVal]) : []
      },
      immediate: true
    },
    reset (newVal) {
      if (newVal) {
        this.prescriptionsLocal = []
      }
    }
  },
  methods: {
    handleChangeCollapse (val) { },
    _normalizePrescription (prescription) {
      if (!prescription) return prescription
      const p = { ...prescription }
      if (!Array.isArray(p.person_medicine) && Array.isArray(p.person_materials)) {
        p.person_medicine = p.person_materials.map(item => ({ ...item }))
      }
      if (!Array.isArray(p.person_medicine)) p.person_medicine = []
      return p
    },
    _normalizeItems (items) {
      return (items || []).map(i => this._normalizePrescription(i))
    },
    getApptStatus (stt) {
      if (stt) {
        return {
          class: 'text-green-600 border-green-600 bg-green-50',
          text: 'Đã ký'
        }
      } else {
        return {
          class: 'text-red-600 border-red-600 bg-red-50',
          text: 'Chưa ký'
        }
      }
    },
    handleUpdateIsPhieuLinh (val) {
      this.isPhieuLinh = val
      this.$emit('updateIsPhieuLinh', val)
    },
    refreshAndOpenPreview (idPrescription, triggerCreateEnvelope) {
      this.$emit('refresh')
    },
    createPrescription () {
      this.$refs.ModalAddPrescription.openDialog()
    },
    onUpdatePrescription (prescription) {
      const normalized = this._normalizePrescription(prescription)

      if (!normalized.id && !normalized._localId) {
        normalized._localId = `tmp_${Date.now()}_${Math.floor(Math.random() * 1000)}`
      }

      const existingIndex = this.prescriptionsLocal.findIndex((p) => {
        if (normalized.id) return p.id === normalized.id
        return p._localId === normalized._localId
      })

      if (existingIndex !== -1) {
        this.$set(this.prescriptionsLocal, existingIndex, normalized)
        const collapseName = `collapse-${existingIndex}`
        if (!this.activeCollapseItems.includes(collapseName)) {
          this.activeCollapseItems.push(collapseName)
        }
      } else {
        this.prescriptionsLocal.push(normalized)
        const newIndex = this.prescriptionsLocal.length - 1
        const newCollapseName = `collapse-${newIndex}`
        if (!this.activeCollapseItems.includes(newCollapseName)) {
          this.activeCollapseItems.push(newCollapseName)
        }
      }
      this.$emit('updatePrescriptions', this.prescriptionsLocal)
    },
    editPrescription (item, idx) {
      if (this.$refs.ModalAddPrescription && this.$refs.ModalAddPrescription.openDialog) {
        this.$refs.ModalAddPrescription.openDialog(item)
      }
    },
    confirmDelete (id, idx) {
      this.$confirm('Bạn có chắc muốn xóa đơn thuốc này?', 'Xác nhận', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Hủy',
        type: 'warning'
      })
        .then(() => {
          if (!id) {
            this.prescriptionsLocal.splice(idx, 1)
            this.$emit('updatePrescriptions', this.prescriptionsLocal)
          } else {
            this.deletePrescription(id)
          }
          const collapseName = `collapse-${idx}`
          this.activeCollapseItems = this.activeCollapseItems.filter(n => n !== collapseName)
        })
        .catch(() => { })
    },
    deletePrescription (id) {
      this.prescriptionsLocal = this.prescriptionsLocal.filter(p => p.id !== id)
      this.$emit('updatePrescriptions', this.prescriptionsLocal)
    },
    getPersonMedicine () {
      this.$emit('refresh')
    },
    formatDateDMY (date_time) {
      return date_time && window.moment(date_time).format('DD/MM/YYYY')
    },
    getTime (date_time) {
      return window.moment(date_time).format('HH:mm:ss')
    },
    viewDetail (prescription) {
      if (prescription?.document_link) {
        window.open(prescription.document_link, '_blank', 'noreferrer')
      }
    },
    toggleCollapse (index) {
      const name = `collapse-${index}`
      if (this.activeCollapseItems.includes(name)) {
        this.activeCollapseItems = this.activeCollapseItems.filter(n => n !== name)
      } else {
        this.activeCollapseItems.push(name)
      }
    },
    formatDate (date) {
      return window.moment(date).format('HH:mm:ss-DD/MM/YYYY')
    },
    getSignAt (item) {
      let time

      if (item.sign) {
        time = window
          .moment(item.sign?.sign_at)
          .utc()
          .format('HH:mm:ss DD/MM/YYYY')
      } else {
        time = window
          .moment(item.updated_at)
          .utc()
          .format('HH:mm:ss DD/MM/YYYY')
      }

      return time
    }
  }
}
</script>
